import { render, staticRenderFns } from "./TeacherTypeEdit.vue?vue&type=template&id=315e7b5a"
import script from "../../controllers/teacher_type/teacher-type-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher_type/teacher-type-edit.js?vue&type=script&lang=js&external"
import style0 from "./TeacherTypeEdit.vue?vue&type=style&index=0&id=315e7b5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports